<template>
  <div class="about_wrap">
    <div class="top-img_container">
      <DragCarousel :images="imgData"></DragCarousel>
    </div>
    <NavTools></NavTools>
    <router-view></router-view>
  </div>
</template>

<script>
  import DragCarousel from '@/components/drag-carousel/index.vue'
  import NavTools from '@/layouts/components/NavTools.vue'
  import { aboutTopCarouselData } from '@/data/aboutData'
  
  export default {
    components: { DragCarousel, NavTools },
    data() {
      return {
        imgData: aboutTopCarouselData
      }
    }
  }
</script>

<style scoped>
  .about_wrap {
    width: 100%;
    height: 100%;
  }
  .top-img_container {
    margin-top: 80px;
    @media screen and (max-width: 768px) {
      margin: 0;
    }
  }
</style>
